var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrandMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 856,
    height: 1496,
    viewBox: "341.5 315.5 214 374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30AD\\u30E3\\u30C3\\u30C1\\u30E3\\u30FC\\u4ED6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.637 528.015h136.934v60.525H389.637v-60.525z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.917 388.54H526.85v139.277H389.917V388.54z",
    fill: "#9a9a9a",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.637 388.54v200H526.57v-200H389.637z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 8,
    stroke: "#000",
    fill: "transparent",
    "data-name": "\\u30D1\\u30B9 1"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u9577\\u65B9\\u5F62 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.265 546.68h73.678v29.41h-73.678v-29.41z",
    fill: "#32ffa0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h73.677v29.41h0H0h0V0h0z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#9a9a9a",
    fill: "transparent",
    transform: "matrix(.9457 0 0 .864 423.265 548.68)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 13"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 3"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.347 468.855l-7.903-18.018.293-2.119 11.178-8.425 1.385-.042.188-3.974-1.757.088-1.056.435-12.99 9.862-.786 4.658 8.083 17.884 5.023 1.65c.15.133.37.014.494-.264.108-.242.084-.134-.023-.292l-2.129-1.443z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 118"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.861 468.855l7.902-18.018-.293-2.119-11.178-8.425-1.384-.042-.189-3.974 1.757.088 1.057.435 12.99 9.862.785 4.658-8.083 17.884-5.023 1.65c-.149.133-.37.014-.494-.264-.108-.242-.083-.134.024-.292l2.13-1.443z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 118"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 6"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.347 468.855l-7.903-18.018.293-2.119 11.178-8.425 1.385-.042.188-3.974-1.757.088-1.056.435-12.99 9.862-.786 4.658 8.083 17.884 5.023 1.65c.15.133.37.014.494-.264.108-.242.084-.134-.023-.292l-2.129-1.443z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 118"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.861 468.855l7.902-18.018-.293-2.119-11.178-8.425-1.384-.042-.189-3.974 1.757.088 1.057.435 12.99 9.862.785 4.658-8.083 17.884-5.023 1.65c-.149.133-.37.014-.494-.264-.108-.242-.083-.134.024-.292l2.13-1.443z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 118"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M457.234 467.981c.067.121.418.215.86.215s.792-.094.86-.215l.29-3.072h.001l-.13-14.797.343-7.524h-2.709l.343 7.524-.144 14.797",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.234 467.981c.067.121.418.215.86.215s.792-.094.86-.215l.29-3.072h.001l-.13-14.797.343-7.524h-2.709l.343 7.524-.144 14.797",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.825 469.281c0 .847-1.219 1.534-2.72 1.534-1.504 0-2.722-.687-2.722-1.534 0-.846 1.218-3.67 2.721-3.67 1.502 0 2.721 2.824 2.721 3.67z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 7",
    fill: "#040000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.104 439.373a6.443 6.443 0 006.436-6.436 6.444 6.444 0 00-6.436-6.436 6.444 6.444 0 00-6.436 6.436 6.444 6.444 0 006.436 6.436z",
    "data-name": "\\u30D1\\u30B9 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.088 432.793c0 4.746 2.044 9.554 5.905 11.775h16.221c3.861-2.221 5.905-7.029 5.905-11.775.001-4.396-2.12-8.299-5.408-10.808h-17.213c-3.288 2.509-5.41 6.412-5.41 10.808zm14.016-7.708c4.33 0 7.853 3.522 7.853 7.852s-3.523 7.853-7.853 7.853-7.852-3.523-7.852-7.853 3.522-7.852 7.852-7.852z",
    "data-name": "\\u30D1\\u30B9 6"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 8",
    fill: "#040000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.104 439.373a6.443 6.443 0 006.436-6.436 6.444 6.444 0 00-6.436-6.436 6.444 6.444 0 00-6.436 6.436 6.444 6.444 0 006.436 6.436z",
    "data-name": "\\u30D1\\u30B9 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.088 432.793c0 4.746 2.044 9.554 5.905 11.775h16.221c3.861-2.221 5.905-7.029 5.905-11.775.001-4.396-2.12-8.299-5.408-10.808h-17.213c-3.288 2.509-5.41 6.412-5.41 10.808zm14.016-7.708c4.33 0 7.853 3.522 7.853 7.852s-3.523 7.853-7.853 7.853-7.852-3.523-7.852-7.853 3.522-7.852 7.852-7.852z",
    "data-name": "\\u30D1\\u30B9 8"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 11"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.347 468.855l-7.903-18.018.293-2.119 11.178-8.425 1.385-.042.188-3.974-1.757.088-1.056.435-12.99 9.862-.786 4.658 8.083 17.884 5.023 1.65c.15.133.37.014.494-.264.108-.242.084-.134-.023-.292l-2.129-1.443z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 118"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.861 468.855l7.902-18.018-.293-2.119-11.178-8.425-1.384-.042-.189-3.974 1.757.088 1.057.435 12.99 9.862.785 4.658-8.083 17.884-5.023 1.65c-.149.133-.37.014-.494-.264-.108-.242-.083-.134.024-.292l2.13-1.443z",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 118"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M457.234 467.981c.067.121.418.215.86.215s.792-.094.86-.215l.29-3.072h.001l-.13-14.797.343-7.524h-2.709l.343 7.524-.144 14.797",
    fill: "#040000",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 12",
    fill: "#040000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.104 439.373a6.443 6.443 0 006.436-6.436 6.444 6.444 0 00-6.436-6.436 6.444 6.444 0 00-6.436 6.436 6.444 6.444 0 006.436 6.436z",
    "data-name": "\\u30D1\\u30B9 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.088 432.793c0 4.746 2.044 9.554 5.905 11.775h16.221c3.861-2.221 5.905-7.029 5.905-11.775.001-4.396-2.12-8.299-5.408-10.808h-17.213c-3.288 2.509-5.41 6.412-5.41 10.808zm14.016-7.708c4.33 0 7.853 3.522 7.853 7.852s-3.523 7.853-7.853 7.853-7.852-3.523-7.852-7.853 3.522-7.852 7.852-7.852z",
    "data-name": "\\u30D1\\u30B9 11"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M450.549 432.54a7.556 7.556 0 110 .1z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2.839,
    stroke: "#32ffa0",
    fill: "transparent",
    "data-name": "\\u6955\\u5186\\u5F62 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.545 492.306h5.118v31.855h-5.118v-31.855z",
    fill: "#32ffa0",
    fillRule: "evenodd",
    "data-name": "\\u9577\\u65B9\\u5F62 7"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 14",
    strokeLinejoin: "round",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.098 464.913v-52.851",
    strokeLinecap: "square",
    strokeWidth: 10,
    stroke: "#9a9a9a",
    "data-name": "\\u7DDA 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.098 464.913v-52.851",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#32ffa0",
    "data-name": "\\u7DDA 2"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.098 407.202V392.82H522.11v14.382",
    strokeWidth: 10,
    stroke: "#9a9a9a",
    "data-name": "\\u30D1\\u30B9 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.098 407.202V392.82H522.11v14.382",
    strokeWidth: 3,
    stroke: "#fff",
    "data-name": "\\u30D1\\u30B9 13"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 16",
    strokeLinejoin: "round",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.098 522.916v-50.851",
    strokeLinecap: "square",
    strokeWidth: 10,
    stroke: "#9a9a9a",
    "data-name": "\\u7DDA 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.098 522.916v-50.851",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#32ffa0",
    "data-name": "\\u7DDA 4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17",
    strokeLinejoin: "round",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.11 464.913v-52.851",
    strokeLinecap: "square",
    strokeWidth: 10,
    stroke: "#9a9a9a",
    "data-name": "\\u7DDA 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.11 464.913v-52.851",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#32ffa0",
    "data-name": "\\u7DDA 6"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18",
    strokeLinejoin: "round",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.11 522.916v-50.851",
    strokeLinecap: "square",
    strokeWidth: 10,
    stroke: "#9a9a9a",
    "data-name": "\\u7DDA 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.11 522.916v-50.851",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#32ffa0",
    "data-name": "\\u7DDA 8"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 19",
    strokeLinejoin: "round",
    strokeLinecap: "square",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.098 585.607v-55.85",
    strokeWidth: 7,
    stroke: "#9a9a9a",
    "data-name": "\\u7DDA 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.098 585.607v-55.85",
    strokeWidth: 3,
    stroke: "#fff",
    "data-name": "\\u7DDA 10"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 20",
    strokeLinejoin: "round",
    strokeLinecap: "square",
    fill: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.11 585.607v-55.85",
    strokeWidth: 7,
    stroke: "#9a9a9a",
    "data-name": "\\u7DDA 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.11 585.607v-55.85",
    strokeWidth: 3,
    stroke: "#fff",
    "data-name": "\\u7DDA 12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.38 432.781a5.991 5.991 0 110 .1z",
    fill: "#595959",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.176 438.257a5.991 5.991 0 110 .1z",
    fill: "#595959",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.667 438.257a5.991 5.991 0 110 .1z",
    fill: "#595959",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.176 496.958a5.991 5.991 0 110 .1z",
    fill: "#595959",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.667 496.958a5.991 5.991 0 110 .1z",
    fill: "#595959",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.38 507.533a5.991 5.991 0 110 .1z",
    fill: "#595959",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.38 561.62a5.991 5.991 0 110 .1z",
    fill: "#595959",
    fillRule: "evenodd",
    "data-name": "\\u6955\\u5186\\u5F62 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.658 438.357l33.842-.857",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#595959",
    fill: "transparent",
    "data-name": "\\u7DDA 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.658 497.058L555.5 561.5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#595959",
    fill: "transparent",
    "data-name": "\\u7DDA 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.372 507.633L555.5 679.5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#595959",
    fill: "transparent",
    "data-name": "\\u7DDA 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.372 432.88L341.5 315.5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#595959",
    fill: "transparent",
    "data-name": "\\u7DDA 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.656 437.733l-53.156.767",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#595959",
    fill: "transparent",
    "data-name": "\\u7DDA 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.656 496.975L341.5 567.5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#595959",
    fill: "transparent",
    "data-name": "\\u7DDA 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.86 562.096L341.5 689.5",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 4,
    stroke: "#595959",
    fill: "transparent",
    "data-name": "\\u7DDA 19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandMachine);
export default __webpack_public_path__ + "static/media/grandMachine.fc7abc41f02d3cdb.svg";
export { ForwardRef as ReactComponent };